
<template>
  <div>

    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{$t(pagetitle)}}</h3>
      </div>
      <leaseback-apartment-inputview></leaseback-apartment-inputview>
    </div>
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title">{{$t('apartmentbookings.bookings_history')}}</h3>
      </div>
      <leaseback-tenant-booking></leaseback-tenant-booking>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <div v-show="infoShow && apartment.status > 1">
      <main-contact-details
        v-show="false"
        :apartment_id="apartment.id"
        @mainperson-save="reload_apartment_details"
        @customer="handleDataCustomer"
      />

      <main-contact-details
        v-if="apartment.not_rent === false"
        :apartment_id="apartment.id"
        :resident_type=" 'tenant' "
        @mainperson-save="reload_apartment_details"
      />
    </div>
    <!---->
    <apartment-assets
      :apartment_id="apartment.id"
      :apartment_code="apartment.apartment_code"
      :apartment_from="apartment.apartment_from"
    />
    <!---->
  </div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import { mapGetters, mapActions } from "vuex";
import MainContactDetails from "./MainContactDetails";
import utils from '@/lib/utils';
import ApartmentAsset from "./ApartmentAssets"
import LeaseBackApartmentInputView from "./LeaseBackApartmentInputView"
import LeaseBackTenantBooking from "./LeaseBackTenantBooking"

export default {
  name: "ApartmentAdd",
  data() {
    return {
      infoShow: false,
      apartmentStatusOptions: [
        { text: "Chưa Bàn Giao", value: 1 },
        { text: "Bàn Giao", value: 2 },
        { text: "Đã Ở", value: 3 }
      ],
      isExistTenant: false,
      pagetitle: "apartment.editaddnew[0]",
      apartment: {
        id: 0,
        apartment_code: "",
        apartment_from: "LeaseBackApartmentDetail",
        size: "",
        status: 1,
        not_rent: true,
        bathroom_count: 0,
        bedroom_count: 0,
        room_count: 0,

        block: "",
        floor:0,
        room:0,
        other_details: ""
      },
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },
      customer_name: "",
      identification_card: ""
    };
  },

  watch: {
    //Get resident data and check exist or not exist tenant
    GET_RESIDENT_DATA: function() {
      for (let i = 0, size = this.GET_RESIDENT_DATA.length; i < size; i++) {
        let resident = this.GET_RESIDENT_DATA[i];
        if (resident.isTenant == true || resident.isTenant == "Yes") {
          this.isExistTenant = true;
        } else {
          this.isExistTenant = false;
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_RESIDENT_DATA",
      "GET_ACCOUNT_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_RESIDENT_LIST",
      "GET_APARTMENT_DETAIL"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    reload_apartment_details: function() {
      let id = this.$route.params.id;
      if (parseInt(id) !== 0) {
        this.GET_APARTMENT_DETAIL({ id: id });
      }
    },
    handleDataCustomer: function(callBackData) {
      this.customer_name =
        callBackData.customer.first_name + callBackData.customer.last_name;
      this.identification_card =
        callBackData.customer.identificationnumber &&
        callBackData.customer.identificationnumber;
    }
  },
  mounted() {
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.apartment.id = parseInt(id);
      this.pagetitle = "apartment.editaddnew[1]";
      this.infoShow = true;
      const data = {
        params: {
          apartment: this.apartment.id
        }
      };
      this.GET_RESIDENT_LIST(data);
      this.GET_APARTMENT_DETAIL({ id: this.apartment.id }).then(
        function(res) {
          let data = res
          this.apartment.apartment_code = data.apartment_code;
        }.bind(this)
      )
    }
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    "main-contact-details": MainContactDetails,
    "apartment-assets": ApartmentAsset,
    "leaseback-apartment-inputview":LeaseBackApartmentInputView,
    "leaseback-tenant-booking":LeaseBackTenantBooking
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackApartmentDetail.vue